let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("8JZKd"), load("f9Wnm"), load("2Gceu"), load("1oAGT"), load("ffEVr"), load("3CJXT")]).then(() => parcelRequire('hGU26'));